export default {
    setSideMenuState(state, payload) {
        state.isSideMenuCollapsed = payload;
    }
}